var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pa-0"},[_c('v-icon',{staticStyle:{"position":"absolute","left":"-6.5px","top":"calc(50% - 7px)"},attrs:{"color":"orange3","size":"14"}},[_vm._v(" mdi-rhombus ")]),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }